import { Component, Input } from "@angular/core";
import { RequestEntity, RequestItem } from "../../Dto/RequestModel";

@Component({
  selector: "app-request-expanded-row",
  standalone: true,
  templateUrl: "./RequestExpandedRowComponent.html",
  styleUrl: "./RequestExpandedRowComponent.scss",
})
export class RequestExpandedRowComponent {
  @Input({ required: true }) request!: RequestEntity;

  getTotalRequested(): number {
    return this.request.items.reduce((sum, requestItem) => sum + Number(requestItem.qty ?? 0), 0);
  }

  getTotalBoxed(): number {
    return this.request.items.reduce((sum, requestItem) => sum + Number(requestItem.boxedQty ?? 0), 0);
  }

  getTotalDispatched(): number {
    return this.request.items.reduce((sum, requestItem) => sum + Number(requestItem.dispatchedQty ?? 0), 0);
  }

  getTotalDelivered(): number {
    return this.request.items.reduce((sum, requestItem) => sum + Number(requestItem.deliveredQty ?? 0), 0);
  }

  getTotalRemaining(): number {
    return this.request.items.reduce((sum, requestItem) => sum + this.getRemainingQty(requestItem), 0);
  }

  getRemainingQty(item: RequestItem): number {
    return Math.max(0, Number(item.qty ?? 0) - Number(item.deliveredQty ?? 0));
  }
}
